import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { makeStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import AddIcon from "@material-ui/icons/Add";
import Container from "@material-ui/core/Container";
import MaterialTable from "material-table";
import {
  addLicenseAction,
  deleteLicenseAction,
  editLicenseAction,
  getLicensesAction,
} from "../../../../../store/license/actions";
import { getSessionData } from "../../../base/helper/baseHelper";
import Base from "../../../base/views/base";
import Popup from "../../../base/views/Popup";
import LandingPageFooter from "../../../LandingPage/views/LandingPageFooter";
import LicenseManagementForm from "./LicenseManagementForm";
import ConfirmationDialog from "../../../base/views/ConfirmationDialog";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    "& .MuiPaper-root": {
      backgroundColor: "rgba(255,255,255,0.5)",
      backdropFilter: "blur(6px)",
      borderRadius: "15px",
      padding: "10px",
      marginTop: "1%",
      justifyContent: "center",
      alignItems: "center",
    },
  },

  pricingheader: {
    marginTop: theme.spacing(2),
  },
  card: {
    height: 400,
    width: "100%",
    maxWidth: 195,
    position: "relative",
    borderRadius: 16,
    display: "flex",
    backgroundColor: "rgba(255,255,255,0.5)",
    backdropFilter: "blur(6px)",
    flexDirection: "column",
    paddingTop: 4,
    paddingBottom: 4,
    "&:last-child": {
      paddingRight: 5,
    },
    flexShrink: 0,
    marginRight: theme.spacing(5),
  },
  cardPricing: {
    display: "flex",
    justifyContent: "center",
    alignItems: "baseline",
    marginBottom: theme.spacing(2),
  },
  cardHeader: {
    fontSize: "small",
  },
  cardpaidlist: {
    paddingTop: 5,
    justifyContent: "center",
    paddingLeft: 10,
  },
  cardpaid: {
    paddingTop: 2,
    paddingLeft: 2,
    fontSize: "small",
    justifyContent: "center",
  },
  planswitcher: {
    paddingBottom: 12,
    paddingTop: 4,
  },
  showallplan: {
    paddingBottom: 12,
    paddingTop: 10,
    justifyContent: "center",
    display: "flex",
  },
  cardpaidlisticon: {
    position: "relative",
    top: 8,
  },
  gridlisticon: {
    position: "relative",
    left: 25,
  },
  appBar: {
    backgroundColor: "rgba(255,255,255,0.5)",
  },
  title: {
    flexGrow: 1,
    color: "rgba(0, 0, 0, 0.7);",
  },
  plantable: {
    backgroundColor: "rgba(255,255,255,0.5)",
    backdropFilter: "blur(6px)",
    marginBottom: "1%",
  },
  plantable2: {
    backgroundColor: "rgba(255,255,255,0.5)",
    backdropFilter: "blur(6px)",
    marginBottom: "1%",
  },
  plantableheader: {
    alignItems: "center",
    display: "inline-flex",
    flexWrap: "Wrap",
    justifyContent: "left",
  },
  container: {
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
    marginBottom: theme.spacing(2),
    borderRadius: "5px",
    backgroundColor: "rgba(255,255,255,0.5)",
    backdropFilter: "blur(8px)",
  },
}));

const headCells = [
  { title: "License No.", field: "licenseno", defaultSort: "asc" },
  { title: "License Type", field: "licensetype" },
  { title: "Email", field: "email" },
  { title: "Valid From", field: "validfrom" },
  { title: "Valid To", field: "validto" },
];

function LicenseManagementLandingPage(props) {
  const classes = useStyles();
  const [recordForEdit, setRecordForEdit] = useState(null);
  const [openPopup, setOpenPopup] = useState(false);
  const [storeId, setStoreId] = useState("");
  const [userId, setUserId] = useState("");
  const [openDialog, setOpenDialog] = useState(false);
  const [deleteLicenseObj, setDeleteLicenseObj] = useState([]);
  const [moduleAccess, setModuleAccess] = useState({});

  const {
    licenses,
    getLicenses,
    addLicense,
    editLicense,
    deleteLicense,
  } = props;

  useEffect(() => {
    setUserId(getSessionData({ key: "userId" }));
    const store = JSON.parse(getSessionData({ key: "store" }));
    setStoreId(store.storeid);
    if (storeId) {
      const userModules = JSON.parse(getSessionData({ key: "userModules" }));
      const employeeModule = userModules.find(
        (module) => module.modulename === "License Management"
      );
      setModuleAccess(employeeModule);
      getLicenses(storeId);
    }
  }, [userId, storeId, getLicenses]);

  const addOrEdit = (resetForm) => {
    resetForm();
    setRecordForEdit(null);
    setOpenPopup(false);
  };

  const openInPopup = (item) => {
    setRecordForEdit(item);
    setOpenPopup(true);
  };

  const onDeleteButtonClick = (e, rowData) => {
    setDeleteLicenseObj({
      storeid: storeId,
      licenseid: rowData.licenseid,
    });
    setOpenDialog(true);
  };

  const handleDelete = () => {
    setOpenDialog(false);
    deleteLicense(deleteLicenseObj);
    setDeleteLicenseObj([]);
  };

  return (
    <div style={{ display: "flex" }}>
      <Base showBaseMenu={true}>
        {/* <h1 style={{ marginTop: "4%" }}>License Management</h1> */}

        <Container
          maxWidth="xl"
          className={classes.container}
          style={{ marginTop: "4%" }}
        >
          <Button
            className={classes.button}
            startIcon={<AddIcon />}
            onClick={() => {
              setOpenPopup(true);
              setRecordForEdit(null);
            }}
            style={{
              backgroundColor: "rgb(22, 177, 255)",
              color: "white",
              borderRadius: "0.5rem",
            }}
            {...{ disabled: moduleAccess.createaccess === "Y" ? false : true }}
          >
            Add New
          </Button>
        </Container>
        <div className={classes.root}>
          <MaterialTable
            title="License List"
            columns={headCells}
            data={licenses}
            actions={[
              {
                icon: "edit",
                tooltip: "Edit",
                onClick: (_event, rowData) => openInPopup(rowData),
                disabled: moduleAccess.editaccess === "Y" ? false : true,
              },
              {
                icon: "delete",
                tooltip: "Delete",
                onClick: (_event, rowData) => {
                  onDeleteButtonClick(_event, rowData);
                },
                disabled: moduleAccess.deleteaccess === "Y" ? false : true,
              },
            ]}
            options={{
              maxBodyHeight: 670,
              paging: true,
              pageSize: 25,
              pageSizeOptions: [25, 50, 100],
              headerStyle: {
                backgroundColor: "rgba(255,255,255,1)",
                color: "black",
              },
            }}
          />
        </div>
        <LandingPageFooter />
        <Popup
          title="License Form"
          openPopup={openPopup}
          setOpenPopup={setOpenPopup}
        >
          <LicenseManagementForm
            recordForEdit={recordForEdit}
            addLicense={addLicense}
            editLicense={editLicense}
            addOrEdit={addOrEdit}
            storeid={storeId}
            userid={userId}
          />
        </Popup>
        <ConfirmationDialog
          title="Do you wish to proceed?"
          openDialog={openDialog}
          closeDialog={setOpenDialog}
          popupTitle="License Management"
          onSubmit={handleDelete}
        />
      </Base>
    </div>
  );
}

const mapStateToDispatch = (state) => ({
  licenses: state.license,
});

const mapDispatchToProps = (dispatch) => {
  return {
    addLicense: (license) => dispatch(addLicenseAction(license)),
    editLicense: (license) => dispatch(editLicenseAction(license)),
    deleteLicense: (license) => dispatch(deleteLicenseAction(license)),
    getLicenses: (licenseId) => dispatch(getLicensesAction(licenseId)),
  };
};

export default connect(
  mapStateToDispatch,
  mapDispatchToProps
)(LicenseManagementLandingPage);
